import { first, isNil } from 'lodash'

export const getFirstMonthDate = (): Date => {
  const date = new Date(),
    y = date.getFullYear(),
    m = date.getMonth()
  return new Date(y, m, 1)
}

export const getFormFormattedDate = (date: Date = new Date()) => first(date.toISOString().split('T'))

export function getToday() {
  return new Date()
}

export function transformApiDate(stringDate?: string | null) {
  return !isNil(stringDate) ? new Date(stringDate) : undefined
}
